import(/* webpackMode: "eager" */ "/app/src/assets/img/tiger-1.webp");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/tiger-2.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/gfx/MagaImage.jsx");
